import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from '@ff-os/shared-react/components/radio-group/Radio';
import classNames from 'classnames';
import styles from './ColorAttributeRadio.module.scss';

export const ColorAttributeRadio = ({ value, label, onClick, active }: Props) => {

    const { t } = useTranslation();

    const classes = classNames(styles.default, {
        [styles.active]: active
    });

    return (
        <Radio key={value} value={value} label={t(label)}
            className={classes} active={active}
            onClick={() => onClick(value)}>
            {t(label)}
            <div className={styles.preview} style={{ backgroundColor: value }} />
        </Radio>
    );
};

type Props = {
    label: string;
    value: string;
    onClick: (value: string) => void;
    active: boolean;
};